module.exports = __webpack_public_path__ + "media/images/icon-administrator-6ada759d3d0e565068096d048d0b1f15.jpg";